// tslint:disable: no-invalid-template-strings
import { ActionType, createAction } from 'typesafe-actions';
import { IListObjectStore } from '../../_common/type';
import {
    EAnnex6V2RecordCode,
    TAnnex6V2BackendRecord,
    TAnnex6V2HistoryFilters,
} from './@types';

enum EAnnex6V2Constants {
    FEATURE = '@annex6-v2',
    // API = '/marpol-annex6v2',
    API = '/api/marpol/all',
}
enum EAnnex6V2Actions {
    HISTORY_LOAD = '@annex6-v2/:history-load',

    HISTORY_SET = '@annex6-v2/${history}/set',
   
    GOTO_DASHBOARD = '@annex6-v2/-->dashboard',
    GOTO_OPERATION_DASHBOARD = '@annex6-v2/-->operation-dashboard',
    GOTO_SELECTED_OPERATION = '@annex6-v2/-->selected-operation',
    GOTO_HISTORY = '@annex6-v2/-->history',
    GOTO_BDN = '@annex6-v2/-->bdn', // BDN
    GOTO_BDN_OPERATION = '@annex6-v2/-->bdn-operation', // BDN
    GOTO_BDN_DISPOSE_OPERATION = '@annex6-v2/-->bdn-dispose-operation', // BDN

    SET_FILTER = '@annex6-v2/:set-filter',
}

const annex6V2Actions = {
    commands: {
        historyLoad: createAction(
            EAnnex6V2Actions.HISTORY_LOAD,
            (providedFilters: TAnnex6V2HistoryFilters) => ({ providedFilters })
        )(),
    },
    document: {
        historySet: createAction(
            EAnnex6V2Actions.HISTORY_SET,
            (history: IListObjectStore<TAnnex6V2BackendRecord>) => ({ history })
        )(),
        setFilter: createAction(EAnnex6V2Actions.SET_FILTER, (filter: any) => ({
            filter,
        }))(),
    },
    routes: {
        gotoDashboard: createAction(EAnnex6V2Actions.GOTO_DASHBOARD)(),
        gotoOperationDashboard: createAction(
            EAnnex6V2Actions.GOTO_OPERATION_DASHBOARD
        )(),
        gotoSelectedOperation: createAction(
            EAnnex6V2Actions.GOTO_SELECTED_OPERATION,
            (operationCode: EAnnex6V2RecordCode) => ({ operationCode })
        )(),
        gotoBDN: createAction(EAnnex6V2Actions.GOTO_BDN)(),
        gotoBDNRecordOperation: createAction(
            EAnnex6V2Actions.GOTO_BDN_OPERATION,
            (recordCode: string, operationMode: 'CREATE' | 'EDIT') => ({
                recordCode,
                operationMode,
            })
        )(),
        gotoBDNRecordDisposeOperation: createAction(
            EAnnex6V2Actions.GOTO_BDN_DISPOSE_OPERATION,
            (recordId: string) => ({ recordId })
        )(),
        gotoHistory: createAction(EAnnex6V2Actions.GOTO_HISTORY)(),
    },
    events: {},
};

export type TAnnex6V2Actions = ActionType<typeof annex6V2Actions>;
export default annex6V2Actions;
export { EAnnex6V2Constants, EAnnex6V2Actions };
